import axiosInstance from "@/shared/api/axiosInstance.js";

export const getSystems = () => {
    return axiosInstance.get('/game-systems');
}